/** @format */
import { css } from 'styled-components';

import { MediaQuery } from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

import { Error500Props } from './index';

/**
 * Base styles for the error 500 component
 *
 * @param {Error500Props} props The error 500 properties object
 * */
const baseStyles = (props: Error500Props) => css`
    padding: 5rem 10%;
    position: relative;
    overflow: hidden;
    min-height: 100%;

    @media${MediaQuery.SMALL_TABLET} {
        padding: 2rem 0;
    }

    .content-buttons {
        position: relative;

        .content-buttons--button {
            border: transparent;
            margin-right: var(--layout-spacing-24);
        }
    }

    .content-container--opaque {
        padding: 2rem;
        background-color: var(--colors-text-secondary);
        z-index: 3;
        position: relative;
        color: var(--colors-text-inverse);
    }

    .content-container {
        max-width: 50rem;
        position: relative;
    }

    .content-copy {
        margin-bottom: var(--layout-spacing-24);
    }

    .logo {
        padding-bottom: 14.4rem;
        padding-left: 2rem;
        position: relative;
        z-index: 3;
        background-color: var(--colors-text-secondary);

        @media${MediaQuery.SMALL_TABLET} {
            padding-bottom: 6.8rem;
        }

        @media${MediaQuery.SMALL_MOBILE} {
            padding-bottom: 4rem;
        }
    }

    .content-headers {
        position: relative;
    }

    .heading-ref {
        ${theme.typography.body_small_highlight}
        color: var(--colors-text-inverse);
    }

    .background-container {
        position: absolute;
        z-index: 2;
        display: flex;
        flex-wrap: wrap;
        transform: rotate(-30deg);
        transform-origin: top left;
        height: 100vh;
        width: 100vw;
        top: 0;
        left: 0;

        @media${MediaQuery.LARGE_TABLET} {
            left: -40rem;
            width: 110vw;
        }

        @media${MediaQuery.SMALL_MOBILE} {
            left: -40rem;
            width: 130vw;
        }
    }

    .background-image--container {
        margin: 0 20rem 20rem 0;
        animation: fadeOutAndIn 20s;
        animation-iteration-count: infinite;
        z-index: 1;
        position: relative;

        @media${MediaQuery.LARGE_TABLET} {
            margin: 0 10rem 10rem 0;
        }
    }

    .background-image--item--intersecting {
        opacity: 0;
    }

    @keyframes fadeOutAndIn {
        0% {
            opacity: 1;
        }
        11% {
            opacity: 0;
        }
        22% {
            opacity: 1;
        }
        100% {
            opacity: 1;
        }
    }
`;

/**
 * The error 500 component styles
 *
 * @param {Error500Props} props The error 500 properties object
 * */
export const styles = (props: Error500Props) => css`
    ${baseStyles(props)}
`;
